module.exports = __webpack_public_path__ + "img/nantun-elementary-school-director.4f59d05d.png";